import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export const LEAD_TAB_LOADER_COLOR = '#6366F1';
export const LEAD_TAB_LOADER_SIZE = 28;
export const LEAD_TAB_LOADER_INLINE_SIZE = 14;

/** Centered spinner for Tasks, Calls, Activity, Notes (lead details v2 tab panels). */
export function LeadTabPanelLoader() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
      <CircularProgress size={LEAD_TAB_LOADER_SIZE} sx={{ color: LEAD_TAB_LOADER_COLOR }} />
    </Box>
  );
}

/** Spinner used inside “Load more” buttons for the same tabs. */
export function LeadTabInlineProgress(props) {
  const { sx, ...rest } = props;
  return (
    <CircularProgress
      size={LEAD_TAB_LOADER_INLINE_SIZE}
      sx={{ mr: 1, color: LEAD_TAB_LOADER_COLOR, ...sx }}
      {...rest}
    />
  );
}

export default LeadTabPanelLoader;
